import { motion } from "framer-motion"
import styled from "styled-components"

export const Holder = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  z-index: 1;
  background-color: white;
`
export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`
